import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchUserFeatures } from "../actions/featureAccessActions";

/**
 * Redirect the user away from the current page if a required feature is not
 * enabled on their plan.
 *
 * @param {number}  featureId   - The FEATURE_IDS constant to check
 * @param {string}  redirectTo  - Where to send them if locked (default: event list)
 * @param {boolean} condition   - Only enforce when true (e.g. type === "paid-event")
 */
const useFeatureRedirect = (
  featureId,
  redirectTo = "/admin/events/create/list",
  condition = true
) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { features, loaded, loading } = useSelector((state) => state.featureAccess);

  // Make sure features are loaded
  useEffect(() => {
    if (!loaded && !loading) {
      dispatch(fetchUserFeatures());
    }
  }, [loaded, loading, dispatch]);

  useEffect(() => {
    if (!condition) return;   // only enforce when the condition is active
    if (!loaded) return;       // wait until feature list is fetched

    const feature = features.find((f) => f.feature_id === featureId);
    const isEnabled = feature ? feature.status === "E" : false;

    if (!isEnabled) {
      navigate(redirectTo, { replace: true });
    }
  }, [loaded, features, featureId, condition, redirectTo, navigate]);
};

export default useFeatureRedirect;
